import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/dist/geosearch.css';
import Styles from './map.module.scss';
import markerIconUrl from '../../assets/marker.webp'; // Import your custom marker icon
import InfoBox from './infoBox.jsx';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';

const Map = () => {
  const [pollutionData, setPollutionData] = useState(null);
  const [location, setLocation] = useState(null);
  const [forecastData, setForecastData] = useState(null);

  useEffect(() => {
    const map = L.map('mapid', {
      scrollWheelZoom: true,
      dragging: true,
    }).setView([33.6844, 73.0479], 11); // Centered on Pakistan with a zoom level of 6
    //  center on islamabad: 33.6844, 73.0479

    // Use a custom tile layer that only shows Pakistan
    L.tileLayer('https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png', {
      maxZoom: 18,
    }).addTo(map);

    const provider = new OpenStreetMapProvider();

    const customIcon = L.icon({
      iconUrl: markerIconUrl,
      iconSize: [20, 25],
      iconAnchor: [12, 41],
    });

    const searchControl = new GeoSearchControl({
      provider,
      showMarker: false, // Set showMarker to false to handle marker manually
      autoComplete: true,
      showPopup: false,
    });
    if (!location)   {
      
      // let { lat, lng } = 33.6844, 73.0479;
      let lat = 33.6844;
      let lng = 73.0479;

      // Check if lat and lng are valid numbers
      if (!isNaN(lat) && !isNaN(lng)) {
        // Remove existing markers on map
        map.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            map.removeLayer(layer);
          }
        });

        // Add new marker at search result location with custom icon
        L.marker([lat, lng], { icon: customIcon }).addTo(map);

        // Fetch location and pollution data
        fetchLocation(lat, lng);
        fetchPollutionData(lat, lng);
        fetchForecastData(lat, lng);
    }}

    map.addControl(searchControl);
    

    // Handle search result event
    map.on('geosearch/showlocation', (e) => {
      const { location } = e;

      // Debug: Log the entire location object to inspect its structure
      console.log('Location object:', location);

      // Extract latitude and longitude from the location object
      const lng = location.x;
      const lat = location.y;
      
      console.log('Longitude:', lng);
      console.log('Latitude:', lat);
      
      // Check if lat and lng are valid numbers
      if (!isNaN(lat) && !isNaN(lng)) {
        // Remove existing markers on map
        map.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            map.removeLayer(layer);
          }
        });

        // Add new marker at search result location with custom icon
        L.marker([lat, lng], { icon: customIcon }).addTo(map);

        // Fetch location and pollution data
        fetchLocation(lat, lng);
        fetchPollutionData(lat, lng);
        fetchForecastData(lat, lng);
      }
    });
    map.on('click', (e) => {
      const { lat, lng } = e.latlng;
      console.log(lat, lng);

      // Check if lat and lng are valid numbers
      if (!isNaN(lat) && !isNaN(lng)) {
        // Remove existing markers on map
        map.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            map.removeLayer(layer);
          }
        });

        // Add new marker at search result location with custom icon
        L.marker([lat, lng], { icon: customIcon }).addTo(map);

        // Fetch location and pollution data
        fetchLocation(lat, lng);
        fetchPollutionData(lat, lng);
        fetchForecastData(lat, lng);
      }
    }
    );

    // Cleanup function to remove the map when component unmounts
    return () => {
      map.remove();
    };
  }, []);

  const fetchForecastData = (latitude, longitude) => {
    fetch(`https://airai-backend-6d7ce85bcde0.herokuapp.com/api/forecast-next-three-days?latitude=${latitude}&longitude=${longitude}`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json(); // Parse the JSON response
    })
    .then(data => {
      const currentDate = new Date(); // Get the current date
      const threeDaysLater = new Date(currentDate); 
      threeDaysLater.setDate(currentDate.getDate() + 3); // Calculate 3 days from now

      const concentrations = data.forecastData
        .filter(item => {
          const forecastDate = new Date(item.date);
          return forecastDate > currentDate && forecastDate <= threeDaysLater;
        })
        .map(item => ({
          date: new Date(item.date).toLocaleDateString(), // Format date as a string
          concentration: item.concentration
        }));

      setForecastData(concentrations);
      console.log(concentrations);
    })
    .catch(error => {
      console.error('Error fetching forecast data:', error); // Log any errors that occur
    });

  };

  const fetchPollutionData = (latitude, longitude) => {
    Promise.all([
      fetch(`https://airai-backend-6d7ce85bcde0.herokuapp.com/api/closest-coordinates/so2?latitude=${latitude}&longitude=${longitude}`),
      fetch(`https://airai-backend-6d7ce85bcde0.herokuapp.com/api/closest-coordinates/no2?latitude=${latitude}&longitude=${longitude}`),
      fetch(`https://airai-backend-6d7ce85bcde0.herokuapp.com/api/closest-coordinates/pm25?latitude=${latitude}&longitude=${longitude}`)
    ])
      .then(responses => Promise.all(responses.map(response => response.json())))
      .then(data => {
        const [so2Data, no2Data, pm25Data] = data;
        setPollutionData({
          so2: so2Data.concentration,
          no2: no2Data.concentration,
          pm25: pm25Data.concentration
        });
      })
      .catch(error => {
        console.error('Error fetching pollution data:', error);
      });
  };

  const fetchLocation = (latitude, longitude) => {
    latitude = parseFloat(latitude);
    longitude = parseFloat(longitude);
    // add latitude and longitude to the URL

    fetch(`https://us1.locationiq.com/v1/reverse?key=pk.07eeda27ac1de8165f3172106764a61b&lat=${latitude}&lon=${longitude}&format=json&`)
      .then(response => response.json())
      .then(data => {
        setLocation(data.display_name);
        console.log(data)
      })
      .catch(error => {
        console.error('Error fetching location:', error);
      });
  }

  return (
    <div>
      <div className={Styles.mapInfo}>
        <p>Air Quality Data Limited to Pakistan. Click anywhere on the map to find the Air Quality Index (AQI) at that point.</p>
      </div>
      <div className={Styles.container}>
      
        <div id="mapid" className={Styles.map}>
        <MapContainer center={[30.3753, 69.3451]} zoom={14} scrollWheelZoom={false} dragging={true}>
        {/* Add the tile layer with Mapbox tiles */}
        <TileLayer
          url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
          attribution='Map data &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
          maxZoom={11}
          id="mapbox/streets-v11"
          tileSize={513}
          zoomOffset={-1}
          accessToken="pk.eyJ1Ijoid2FmdGFiIiwiYSI6ImNscHpwN2dkOTFicW8ya285YWc0cjJyb3QifQ.EKY3yi9nnjmVEr28gUv3Kw"
        />
          </MapContainer>
        </div>
        {location && forecastData && (
          <div className={Styles.InfoBox}>
            <InfoBox pollutionData={pollutionData} location={location} forecastData={forecastData} />
          </div>
        )}
      </div>
    </div>
  );
};

export { Map };
